import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import {
  Document, Image, Page,
  PDFViewer, StyleSheet, Text, View
} from "@react-pdf/renderer";
import { OrderType } from "models/order_type";
import moment from "moment";
import Logo from "../../../../assets/img/logo/Byrd_Logo.png";

interface IPrint {
  order: OrderType;
  show: boolean;
  showModal: (show: boolean) => void;
}


// Create styles
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  image : {
    width : 64,
    height : 64,
    padding : 10,
    marginTop : 12
  },
  h1 : {
    alignSelf: 'center',
    fontSize :  28,
    marginTop : 8
  },
  textoData: {
    fontSize :  10,
    marginTop :  28,
    marginRight :  12,
    fontStyle : "italic",
    color : "white"
  },
  hr:{
   border : 0.5,
   marginHorizontal: 12,   
  },
  row: {
    flexDirection : "row",
    justifyContent : "space-between"
  },
  row1: {
    flexDirection : "row",
  },
  texto : {
    fontStyle : "bold",
    fontSize : 12,
    marginTop : 16,
    marginLeft : 6  
  },
  textoNormal : {
    fontStyle : "bold",
    fontSize : 12,
    marginLeft : 12,
    marginTop : 16
  }
});

const Print = ({ order, show, showModal }: IPrint) => {
  return (
    <Modal
      onClose={() => {
        showModal(false);
      }}
      size={"6xl"}
      isOpen={show}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Impressão de Orçamento</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <PDFViewer width={"100%"} height={1024}>
            <Document>
              <Page size="A4" style={styles.page}>
                 <View style={styles.row}>
                    <Image src={Logo} style={styles.image} />
                    <Text style={styles.h1}>Orçamento Broders</Text>
                    <Text style={styles.textoData}>{moment(order?.data).format("DD/MM/yyyy HH:mm")}</Text>
                 </View>
                 <View style={styles.hr} />
                 <View style={styles.row1}>
                 <Text style={styles.textoNormal}>Cliente:</Text>
                 <Text style={styles.texto}>{order?.cliente?.nome}</Text>

                 </View>
              </Page>
            </Document>
          </PDFViewer>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              showModal(false);
            }}
            variant="outline"
            marginRight={4}
          >
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
export default Print;
